import { render, staticRenderFns } from "./ApfRedirectFromKagami.vue?vue&type=template&id=49f2725e"
import script from "./ApfRedirectFromKagami.vue?vue&type=script&lang=js"
export * from "./ApfRedirectFromKagami.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports